<template>
  <div class="container">
    <span>Ingresando...</span>
  </div>
</template>

<script>
import md5 from 'js-md5'

export default {
  props: {
    guid: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      socData: null,
      TipoPerfilEjecutivo:'',
      token: '',
      sessionReady: false,
    }
  },
  async mounted() {

    // return console.log(this.guid)
    await this.getTokenSisec();

    if ( !this.guid ) {
      // El multilogin fallo y termino su proceso de inicio
      localStorage.setItem('multiLoginLoading', false);
      return this.$router.push('/login').catch(() => {})
    }

    const isInmobiliaria = this.guid.includes('@') || false;

    isInmobiliaria ? this.ObtenCredenciales() : this.verificaUsuario();
  },
  methods: {
    async getTokenSisec() {
      const self = this
      let objRequestToken = {
        strApiKey: "a13768e0b29183037ac1f3acb68871bc",
        strMetodo: 'DameAuthToken',
      }
      try {
        const response = await this.$axios.post('/', objRequestToken,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
        if (response.data && !response.data.error && response.data.access_token) {
          this.token = response.data.access_token
        } else {
          this.$vs.notify({
            title: 'Ocurrio un error al obtener token',
            text: (response.data && response.data.error_description) || 'Sin access_token',
            color: 'danger',
            position: 'top-right',
          })
        }
      } catch (error) {
        self.$vs.notify({
          title: 'Ocurrio un error de sistema',
          text: error,
          color: 'danger',
          position: 'top-right',
        })
      }
    },

    // Multilogin Inmobiliaria
    ObtenCredenciales() {

      const self = this
      const objRequestAutentica = {
        strApiKey: "a13768e0b29183037ac1f3acb68871bc",
        strMetodo: "DameDatosInmobiliario",
        objEjecutivo: { email: this.guid }
      }

      this.$axios
        .post("/", objRequestAutentica, {headers: {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"}})
        .then(response => {
          const status = response.data.intEstatus

          if ( status ) {

            this.$vs.notify({
              title: "Ocurrio un error en DameDatosInmobiliario",
              text: response.data.strError,
              color: "danger",
              position: "top-right",
            })

          }

          localStorage.setItem('userInfo', JSON.stringify(response.data.objContenido))
          this.$store.commit("UPDATE_USER_INFO", response.data.objContenido)
          this.$router.push("/homeInmo").catch(() => {})
          // El multilogin termino su proceso de inicio
          localStorage.setItem('multiLoginLoading', false);
        })
        .catch(function (error) {
          self.$vs.notify({
            title: "Ocurrio un error de sistema Aute",
            text: error,
            color: "danger",
            position: "top-right"
          })

          self.$router.push('/login').catch(() => {})
          // El multilogin falló y termino su proceso de inicio
          localStorage.setItem('multiLoginLoading', false);
        })
    },

    // Multilogin SOC
    verificaUsuario() {

      const self = this
      if (!this.token) {
        localStorage.setItem('multiLoginLoading', false)
        this.$vs.notify({
          title: 'No se pudo autenticar con SISEC',
          text: 'DameAuthToken no devolvió access_token.',
          color: 'danger',
          position: 'top-right',
        })
        return this.$router.push('/login').catch(() => {})
      }

      localStorage.setItem('multiLoginLoading', true)

      // https: con http el redirect pierde el Bearer y GetEmployee responde 401 → login
      const URL = `https://preprodapivalidacionriesgos.sisec.mx/api/External/GetEmployee?id=${ this.guid }`
      const header = {
        "Authorization": "Bearer " + this.token
      }

      this.$axios
        .get(URL,{headers : header})
        .then(response => {

          this.socData = response.data
          const data = response.data
          const userStatus = data && data.Status

          // Solo login si GetEmployee no trae empleado activo
          if ( !data || userStatus !== 'Activo' ) {
            localStorage.setItem('multiLoginLoading', false)
            return this.$router.push('/login').catch(() => {})
          }

          // Empleado OK → seguir en "Ingresando..." y armar sesión → /
          localStorage.setItem('socData', JSON.stringify(data))
          this.$store.commit('UPDATE_SOC_DATA', data)

          const ownerMail = data.OwnerMail
          const mail = data.Mail
          const isSupervisor = ownerMail === mail || false

          if ( isSupervisor ) {

            this.autenticaEjecutivoSOC(
              mail,
              this.guid,
              data.EmployeeName,
              data.CommercialReason,
              data.OwnerMail,
              data.OwnerId,
              data.OwnerName,
              data.BrokerId,
              true,
              data.Curp,
              data.Rfc,
              data.CurpCommercial,
              data.RfcCommercia,
              data.EmployeeRol,
              data.NoBroker
            )

          }
          else {

            this.autenticaEjecutivoSOC(
              data.OwnerMail,
              data.OwnerId,
              data.OwnerName,
              data.CommercialReason,
              data.OwnerMail,
              data.OwnerId,
              data.OwnerName,
              data.BrokerId,
              false,
              data.Curp,
              data.Rfc,
              data.CurpCommercial,
              data.RfcCommercia,
              data.EmployeeRol,
              data.NoBroker
            )

            this.autenticaEjecutivoSOC(
              mail,
              this.guid,
              data.EmployeeName,
              data.CommercialReason,
              data.OwnerMail,
              data.OwnerId,
              data.OwnerName,
              data.BrokerId,
              true,
              data.Curp,
              data.Rfc,
              data.CurpCommercial,
              data.RfcCommercia,
              data.EmployeeRol,
              data.NoBroker
            )

          }

        })
        .catch(error => {
          // Fallo real de GetEmployee → login
          self.$vs.notify({
            title: 'Ocurrio un error de sistema',
            text: error,
            color: 'danger',
            position: 'top-right',
          })

          localStorage.setItem('multiLoginLoading', false)
          this.$router.push('/login').catch(() => {})
        })
    },

    autenticaEjecutivoSOC ( email, pass, nombre, CommercialReason, supervisor, idSupervisor, nameSupervisor, idBroker, isSupervisor, curp, rfc, curpSupervisor, rfcSupervisor, EmployeeRol, NoBroker) {
      
      if(EmployeeRol=='Asesor'){
        this.TipoPerfilEjecutivo=5
      }else if(EmployeeRol=='CUENTA MAESTRA' || EmployeeRol=='Cuenta maestra 3.0' || EmployeeRol=='Cuenta Maestra Venta Cruzada' || EmployeeRol=='CuentaMaestraSOC'){
        this.TipoPerfilEjecutivo=1
      }else if(EmployeeRol=='Gerente'){
        this.TipoPerfilEjecutivo=2
      }else if(EmployeeRol=='Operador' || EmployeeRol=='Operador 3.0' || EmployeeRol=='Operador Venta Cruzada' || EmployeeRol=='OperadorSOC' ){
        this.TipoPerfilEjecutivo=3
      }else if(EmployeeRol=='OPERADORADMINISTRADOR'){
        this.TipoPerfilEjecutivo=4
      }else if(EmployeeRol=='Agente'){
        this.TipoPerfilEjecutivo=8
      }
      const self = this
      const objRequestAutentica = {
        strApiKey: 'a13768e0b29183037ac1f3acb68871bc',
        strMetodo: 'autenticaEjecutivoSOC',
        objEjecutivo: {
          EMail: email,
          Password: md5(pass),
          Guid: this.guid,
          SocGuid: isSupervisor ? this.guid : idSupervisor,
          Nombre: nombre,
          Curp: curp,
          Rfc: rfc, 
          RazonComercial: CommercialReason,
          CommercialReason: CommercialReason,
          OwnerMail: supervisor,
          CurpCommercial: isSupervisor ? curpSupervisor : '',
          RfcCommercia: isSupervisor ? rfcSupervisor : '',
          TipoPerfilEjecutivo:  this.TipoPerfilEjecutivo,
          IdBrokerSisec: NoBroker,
          BrokerId: idBroker
        }
      }

      this.$axios.post('/',objRequestAutentica,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {

          const status = response.data.intEstatus

          if ( status ) {
            return this.registraEjecutivo( email, pass, nombre, CommercialReason, supervisor, idSupervisor, nameSupervisor, idBroker, isSupervisor, curp, rfc, curpSupervisor, rfcSupervisor , EmployeeRol, NoBroker)
          }

          if ( !isSupervisor ) return

          // GetEmployee OK + sesión lista → / (Soc carga casos). Sin 2º autentica.
          if (response.data.objContenido) {
            this.irAHomeConSesion(response.data.objContenido)
          } else {
            this.login( email, pass, nombre, CommercialReason, curp, rfc , EmployeeRol, NoBroker, supervisor)
          }

        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema7',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },

    irAHomeConSesion(objContenido) {
      if (this.sessionReady || !objContenido) return
      this.sessionReady = true

      localStorage.setItem('userInfo', JSON.stringify(objContenido))
      if (this.socData) {
        localStorage.setItem('socData', JSON.stringify(this.socData))
      }
      this.$store.commit('UPDATE_USER_INFO', objContenido)
      this.$store.commit('UPDATE_SOC_DATA', this.socData)

      // Mantener multiLoginLoading hasta estar en home con userInfo
      this.$router.replace({ name: 'home' }).then(() => {
        localStorage.setItem('multiLoginLoading', false)
      }).catch(() => {
        localStorage.setItem('multiLoginLoading', false)
        this.$router.replace('/').catch(() => {})
      })
    },
    registraEjecutivo( email, pass, nombre, CommercialReason, supervisor, idSupervisor, nameSupervisor, idBroker,isSupervisor, curp, rfc, curpSupervisor, rfcSupervisor, EmployeeRol, NoBroker ) {

      if(EmployeeRol=='Asesor'){
        this.TipoPerfilEjecutivo=5
      }else if(EmployeeRol=='CUENTA MAESTRA' || EmployeeRol=='Cuenta maestra 3.0' || EmployeeRol=='Cuenta Maestra Venta Cruzada' || EmployeeRol=='CuentaMaestraSOC'){
        this.TipoPerfilEjecutivo=1
      }else if(EmployeeRol=='Gerente'){
        this.TipoPerfilEjecutivo=2
      }else if(EmployeeRol=='Operador' || EmployeeRol=='Operador 3.0' || EmployeeRol=='Operador Venta Cruzada' || EmployeeRol=='OperadorSOC' ){
        this.TipoPerfilEjecutivo=3
      }else if(EmployeeRol=='OPERADORADMINISTRADOR'){
        this.TipoPerfilEjecutivo=4
      }


      const self = this
      const objRequestRegistraEjecutivo = {
        strApiKey: 'a13768e0b29183037ac1f3acb68871bc',
        strMetodo: "RegistraEjecutivo",
        objEjecutivo: {
          EMail: email,
          Nombre: nombre,
          Telefono:'1234567890',
          Password: md5(pass),
          TipoBroker: 1,
          Organizacion: 3,
          Activo: 1,
          BuroCredito: true,
          EMailSupervisor: !isSupervisor ? supervisor : '',
          SocGuid : !isSupervisor ? idSupervisor : this.guid,
          OwnerId: idSupervisor,
          OwnerName: nameSupervisor,
          OwnerMail: supervisor,
          BrokerId: idBroker,
          CommercialReason: CommercialReason,
          Curp: curp,
          Rfc: rfc,
          //OwnerCurp: !isSupervisor ? curpSupervisor : '',
          //OwnerRfc: !isSupervisor ? rfcSupervisor : '',
          CurpCommercial: isSupervisor ? curpSupervisor : '',
          RfcCommercia: isSupervisor ? rfcSupervisor : '',
          TipoPerfilEjecutivo: this.TipoPerfilEjecutivo,
          IdBrokerSisec: NoBroker
        }
      }

      this.$axios.post('/',objRequestRegistraEjecutivo,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {

          const status = response.data.intEstatus

          if ( status ) {
            return this.$vs.notify({
              title:'Ocurrio un error en RegistraEjecutivo',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }

          if ( !isSupervisor ) return

          // Tras registrar, autenticar para obtener ApiKey en sesión
          this.login( email, pass, nombre, CommercialReason, curp, rfc , EmployeeRol, NoBroker, supervisor)

        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema8',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },

    login( email, pass, nombre, CommercialReason, curp, rfc , EmployeeRol, NoBroker, ownerMail) {
      if (this.sessionReady) return

       if(EmployeeRol=='Asesor'){
        this.TipoPerfilEjecutivo=5
      }else if(EmployeeRol=='CUENTA MAESTRA' || EmployeeRol=='Cuenta maestra 3.0' || EmployeeRol=='Cuenta Maestra Venta Cruzada' || EmployeeRol=='CuentaMaestraSOC'){
        this.TipoPerfilEjecutivo=1
      }else if(EmployeeRol=='Gerente'){
        this.TipoPerfilEjecutivo=2
      }else if(EmployeeRol=='Operador' || EmployeeRol=='Operador 3.0' || EmployeeRol=='Operador Venta Cruzada' || EmployeeRol=='OperadorSOC' ){
        this.TipoPerfilEjecutivo=3
      }else if(EmployeeRol=='OPERADORADMINISTRADOR'){
        this.TipoPerfilEjecutivo=4
      }

      const self = this
      const objRequestAutentica = {
        strApiKey: 'a13768e0b29183037ac1f3acb68871bc',
        strMetodo: 'autenticaEjecutivoSOC',
        objEjecutivo: {
          EMail: email,
          Password: md5(pass),
          Guid: this.guid,
          SocGuid: this.guid,
          Nombre:nombre,
          Curp: curp,
          Rfc:rfc,
          RazonComercial: CommercialReason,
          CommercialReason: CommercialReason,
          OwnerMail: ownerMail || (this.socData && this.socData.OwnerMail) || email,
          CurpCommercial: this.socData && this.socData.CurpCommercial ? this.socData.CurpCommercial : '',
          RfcCommercia: this.socData && this.socData.RfcCommercia ? this.socData.RfcCommercia : '',
          TipoPerfilEjecutivo: this.TipoPerfilEjecutivo,
          IdBrokerSisec: NoBroker,
          BrokerId: this.socData && this.socData.BrokerId ? this.socData.BrokerId : null
        }
      }

      this.$axios.post('/',objRequestAutentica,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {

          const status = response.data.intEstatus

          if ( status ) {
            return this.$vs.notify({
              title:'Ocurrio un error en autenticaEjecutivoSOC',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }

          this.irAHomeConSesion(response.data.objContenido)

        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema Aute',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },

  },
};
</script>

<style scoped>
.container {
  width: 100%;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
